<template>

    <div>


        <div class="container section">
            <div class="row heading">
                <div class="col">
                    <h2>Quotes</h2>
                </div>
            </div>


            <div class="row lined" v-for="l, i in leadCarrierLocationProducts" >
                <div class="col-12 carrier-location">
                    <strong>{{l.location.formatted_address}}</strong>
                </div>
                <div class="container carrier-product-container " v-if="l.carrierProducts.length">
                    <div class="row lined" v-for="p in l.carrierProducts">
                        <div class="col-6">
                            <strong>{{p.carrierProductName}}</strong><br />
                            {{p.carrierProductAccess}}/{{p.carrierProductCriteria}}
                        </div>
                        <div class="col-2">
                            <strong>QTY: </strong>{{p.qty}}<br />
                            <strong>TERM: </strong>{{p.term}}<br />
                        </div>
                        <div class="col-2">
                            <strong>MRC: </strong>{{p.mrc}}<br />
                            <strong>NRC: </strong>{{p.nrc}}<br />
                        </div>
                        <div class="col-2 text-right">
                            <dropdown-confirmation
                                    @confirm="deleteProduct(p)">
                            </dropdown-confirmation>
                        </div>
                    </div>
                </div>
                <div v-else class="container " >
                    <div class="row">
                        <div class="col">
                            <em class="subdued">There are no products quoted</em>

                        </div>
                    </div>
                </div>
            </div>





            <div class="row" >
                <div class="col">
                    <button @click="createQuote = true" class="btn btn-primary">Create Quote</button>
                </div>
            </div>
            <modal allow-click-away="false" v-if="createQuote" size="xl">
                <div slot="header">
                    <h3 class="modal-title d-inline d-flex justify-content-start">Create Quote</h3>
                    <button type="button" class="btn btn-clear close-btn" @click="resetQuote" >
                        <i class="fa fa-remove"  />
                    </button>
                </div>
                </h3>

                <div slot="body">
                    <quote
                        @close="createQuote = false"
                        @refetch="getQuoteData"
                        :details="details"
                        :carrier="activeCarrier"
                    ></quote>
                </div>
            </modal>
        </div>
     </div>




</template>
<script type="text/babel">
    import Modal from '../assets/Modal.vue';
    import Quote from './Quote.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    export default {
        name: "LeaseQuotes",
        data: function () {
            return {
                createQuote: false,
                activeCarrier: {},
                leadCarrierLocationProducts: {},

                num_pages: 0,
                paginate:{
                    current_page: 1,
                    limit: 5,
                    offset:0
                },
            }
        },
        components:{
            Modal,
            Quote,
            DropdownConfirmation
        },
        created(){
            this.activeCarrier = JSON.parse(JSON.stringify(this.carrier))
            this.getQuoteData();

        },
        methods:{
            resetQuote(){
                this.createQuote = false;
            },
            getQuoteData(){
                this.$send(this, 'leadCarrierLocationProducts', {
                    leadCarrier_id: this.activeCarrier.leadCarrier_id
                }).then( r => {
                     this.leadCarrierLocationProducts = r.leadCarrierLocationProducts
                })
            },
            deleteProduct(){

            }

        },
        props:['carrier', 'details', 'leadCarrier_id'],
        watch:{
            carrier(newCarrier){
                this.activeCarrier = JSON.parse(JSON.stringify(newCarrier));
                this.getQuoteData();

            }
        }
    }
</script>
<style scoped>
    .carrier-location{
        color: #777;
        font-weight: 600;
        font-size: .75rem;
    }
    .carrier-product-container{
        padding: 10px 30px;
        background: #e3eaf1;
    }
</style>


// WEBPACK FOOTER //
// LeadQuotes.vue?f96dedec